const SIGNUP = 'STEP_SIGNUP'
const CONFIRMATION = 'STEP_CONFIRMATION'
const PLAN = 'STEP_PLAN'
const PROSPECT = 'STEP_PROSPECT'
const WRITER = 'STEP_WRITER'
const WELCOME = 'STEP_WELCOME'
const TEMPLATE = 'STEP_TEMPLATE'
const RECON = 'STEP_RECON'
const CUSTOMERS = 'STEP_CUSTOMERS'
const CRITERIA = 'STEP_CRITERIA'
const CONGRATULATIONS = 'STEP_CONGRATULATIONS'
const SIGNUP_STEPS = {
  SIGNUP,
  CONFIRMATION,
  PLAN,
  PROSPECT,
  WRITER,
  WELCOME,
  TEMPLATE,
  RECON,
  CUSTOMERS,
  CRITERIA,
  CONGRATULATIONS,
}

export const ReportColumns = [
  { name: 'EMAIL SENT', value: 'Send Date' },
  { name: 'CONTACT', value: 'Name' },
  { name: 'EMAIL + COMPANY NAME', value: 'Recipient' },
  { name: 'SUBJECT', value: 'Subject' },
  { name: 'MANEUVER', value: 'Maneuver' },
  { name: 'MISSION', value: 'Touch' },
  { name: 'OPENED', value: 'Opened Count' },
  { name: 'REPLIED', value: 'Replied' },
]

export const HangarColumns = [
  { name: 'NAME + TITLE', value: 'name' },
  { name: 'PHONE + EMAIL', value: 'email' },
  { name: 'COMPANY', value: 'company' },
  { name: 'STATUS', value: 'status' },
  { name: 'RANK', value: 'rank' },
]

export default SIGNUP_STEPS

export const headCountPrefill = [
  'All',
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1000',
  '1001-5000',
  '5001-10000',
  '10000+',
]

export const locationPrefill = [
  'All US States',
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]

export const seniorityLevelPrefill = ['All', 'C-Level', 'VP', 'Director', 'Manager']
export const revenuesPrefill = [
  'All',
  '$0m - $10m',
  '$10m - $20m',
  '$20m - $30m',
  '$30m - $40m',
  '$40m - $50m',
  '$50m - $60m',
  '$60 - $70m',
  '$70m - $80m',
  '$80m - $90m',
  '$90m - $100m',
  '$100m - $200m',
  '$200m - $300m',
  '$300m - $400m',
  '$400m - $500m',
  '$500m - $600m',
  '$600m - $700m',
  '$700m - $800m',
  '$800m - $900m',
  '$900m - $1B',
  '$1B +',
]
export const industriesPrefill = [
  'Accounting',
  'Accomodation',
  'Administration of Justice',
  'Advertising Services',
  'Airlines/Aviation',
  'Alternative Dispute Resolution',
  'Alternative Medicine',
  'Ambulance Services',
  'Amusement Parks',
  'Animation',
  'Apparel and Fashion',
  'Appliance, Electrical and Electronics Manufacturing',
  'Architecture and Planning',
  'Armed Forces',
  'Arts and Crafts',
  'Automotive',
  'Aviation and Aerospace',
  'Banking',
  'Biotechnology',
  'Blockchain Services',
  'Blogs',
  'Breweries',
  'Broadcast Media',
  'Building Materials',
  'Business Consulting and Services',
  'Business Supplies and Equipment',
  'Capital Markets',
  'Caterers',
  'Chemicals',
  'Child Day Care Services',
  'Chiropractors',
  'Civic and Social Organization',
  'Civil Engineering',
  'Commercial Real Estate',
  'Community Services',
  'Computer and Network Security',
  'Computer Games',
  'Computer Hardware Manufacturing',
  'Computer Networking Products',
  'Computer Software',
  'Conservation Programs',
  'Construction',
  'Consumer Electronics',
  'Consumer Goods',
  'Consumer Services',
  'Cosmetics',
  'Dairy Product Manufacturing',
  'Dance Companies',
  'Defense and Space Manufacturing',
  'Design',
  'E-Learning',
  'Economic Programs',
  'Education Management',
  'Electrical/Electronic Manufacturing',
  'Electrical Equipment Manufacturing',
  'Entertainment Providers',
  'Environmental Services',
  'Emergency and Relief Services',
  'Events Services',
  'Executive Office',
  'Facilities Services',
  'Farming',
  'Financial Services',
  'Fine Art',
  'Fishery',
  'Food & Beverage Manufacturing',
  'Food Production',
  'Forestry and Logging',
  'Fund-Raising',
  'Furniture',
  'Gambling & Casinos',
  'Glass, Ceramics & Concrete',
  'Golf Courses and Country Clubs',
  'Government Administration',
  'Government Relations',
  'Graphic Design',
  'Ground Passenger Transport',
  'Health, Wellness and Fitness',
  'Higher Education',
  'Highway, Street and Bridge Construction',
  'Historical Sites',
  'Hospital and Health Care',
  'Hospitality',
  'Hotels and Motels',
  'Housing Programs',
  'Household Services',
  'Human Resources',
  'Import and Export',
  'Individual & Family Services',
  'Industrial Automation',
  'Industrial Machinery Manufacturing',
  'Information Services',
  'Information Technology and Services',
  'Insurance',
  'Interior Design',
  'International Affairs',
  'International Trade and Development',
  'Internet',
  'Internet Marketplace Platforms',
  'Investment Banking',
  'Judiciary',
  'Law Enforcement',
  'Law Practice',
  'International Affairs',
  'Investment Management',
  'Legal Services',
  'Legislative Offices',
  'Leisure, Travel and Tourism',
  'Libraries',
  'Logistics and Supply Chain',
  'Luxury Goods and Jewelry',
  'Machinery',
  'Management Consulting',
  'Maritime',
  'Market Research',
  'Marketing and Advertising',
  'Maritime Transportation',
  'Meat Products Manufacturing',
  'Mechanical and Industrial Engineering',
  'Media Production',
  'Medical Devices',
  'Medical Practices',
  'Mental Health Care',
  'Military',
  'Mining and Metals',
  'Mobile Games',
  'Motion Pictures and Film',
  'Motor Vehicle Manufacturing',
  'Museums and Institutions',
  'Music',
  'Nanotechnology',
  'Natural Gas Distribution',
  'Newspapers',
  'Nonprofit Organization Management',
  'Oil Extraction',
  'Oil and Gas',
  'Oil, Gas and Mining',
  'Online Media',
  'Optometrists',
  'Operations Consulting',
  'Outpatient Care Centers',
  'Outsourcing/Offshoring',
  'Package/Freight Delivery',
  'Packaging and Containers',
  'Paper and Forest Products',
  'Performing Arts',
  'Pet Services',
  'Pharmaceuticals',
  'Philanthropic Fundraising Services',
  'Photography',
  'Physical, Occupatonal and Speech Therapy',
  'Plastics Manufacturing',
  'Plastics and Rubber Manufacturing',
  'Political Organizations',
  'Primary/Secondary Education',
  'Printing',
  'Professional Training and Coaching',
  'Program Development',
  'Public Health',
  'Public Policy Offices',
  'Public Relations and Communications',
  'Public Safety',
  'Publishing',
  'Racetracks',
  'Railroad Manufacturer',
  'Ranching',
  'Real Estate',
  'Recreational Facilities and Services',
  'Religious Institutions',
  'Renewable Energy Power Generation',
  'Renewable Energy Equipment',
  'Renewables and Environment',
  'Research Services',
  'Restaurants',
  'Retail',
  'Retail Appliances',
  'Retail Gasoline',
  'Retail Florists',
  'Retail Motor Vehicles',
  'Satellite Telecommunications',
  'Securities and Commodity Exchanges',
  'Security and Investigations',
  'Services for the Elderly and Disabled',
  'Semiconductor Manufacturing',
  'Shipbuilding',
  'Skiing Facilities',
  'Software Development',
  'Space Research and Technology',
  'Sporting Goods',
  'Sports Teams and Clubs',
  'Staffing and Recruiting',
  'Sugar and Confectionary Products',
  'Supermarkets',
  'Technology, Information and Internet',
  'Telecommunications',
  'Textiles',
  'Theater Companies',
  'Think Tanks',
  'Tobacco Manufacturing',
  'Translation and Localization',
  'Transportation/Trucking/Railroad',
  'Transportation Equipment Manufacturing',
  'Urban Transit Services',
  'Utilities',
  'Utilities Administration',
  'Utility System Construction',
  'Vehicle Repair and Maintenance',
  'Venture Capital and Private Equity',
  'Veterinary',
  'Vocational Rehabilitation',
  'Warehousing',
  'Water Supply and Irrigation',
  'Wholesale',
  'Wholesale Building Materials',
  'Wholesale Hardware',
  'Wholesale Machinery',
  'Wholesale Metals',
  'Wholesale Petroleum',
  'Wholesale Recyclable Materials',
  'Wine and Spirits',
  'Wireless',
  'Writing and Editing',
  'Zoos and Botanical Gardens',
]

export const cityNamePrefill = [
  'All US Cities',
  'Aberdeen',
  'Abilene',
  'Akron',
  'Albany',
  'Albuquerque',
  'Alexandria',
  'Allentown',
  'Amarillo',
  'Anaheim',
  'Anchorage',
  'Ann Arbor',
  'Antioch',
  'Apple Valley',
  'Appleton',
  'Arlington',
  'Arvada',
  'Asheville',
  'Athens',
  'Atlanta',
  'Atlantic City',
  'Augusta',
  'Aurora',
  'Austin',
  'Bakersfield',
  'Baltimore',
  'Barnstable',
  'Baton Rouge',
  'Beaumont',
  'Bel Air',
  'Bellevue',
  'Berkeley',
  'Bethlehem',
  'Billings',
  'Birmingham',
  'Bloomington',
  'Boise',
  'Boise City',
  'Bonita Springs',
  'Boston',
  'Boulder',
  'Bradenton',
  'Bremerton',
  'Bridgeport',
  'Brighton',
  'Brownsville',
  'Bryan',
  'Buffalo',
  'Burbank',
  'Burlington',
  'Cambridge',
  'Canton',
  'Cape Coral',
  'Carrollton',
  'Cary',
  'Cathedral City',
  'Cedar Rapids',
  'Champaign',
  'Chandler',
  'Charleston',
  'Charlotte',
  'Chattanooga',
  'Chesapeake',
  'Chicago',
  'Chula Vista',
  'Cincinnati',
  'Clarke County',
  'Clarksville',
  'Clearwater',
  'Cleveland',
  'College Station',
  'Colorado Springs',
  'Columbia',
  'Columbus',
  'Concord',
  'Coral Springs',
  'Corona',
  'Corpus Christi',
  'Costa Mesa',
  'Dallas',
  'Daly City',
  'Danbury',
  'Davenport',
  'Davidson County',
  'Dayton',
  'Daytona Beach',
  'Deltona',
  'Denton',
  'Denver',
  'Des Moines',
  'Detroit',
  'Downey',
  'Duluth',
  'Durham',
  'El Monte',
  'El Paso',
  'Elizabeth',
  'Elk Grove',
  'Elkhart',
  'Erie',
  'Escondido',
  'Eugene',
  'Evansville',
  'Fairfield',
  'Fargo',
  'Fayetteville',
  'Fitchburg',
  'Flint',
  'Fontana',
  'Fort Collins',
  'Fort Lauderdale',
  'Fort Smith',
  'Fort Walton Beach',
  'Fort Wayne',
  'Fort Worth',
  'Frederick',
  'Fremont',
  'Fresno',
  'Fullerton',
  'Gainesville',
  'Garden Grove',
  'Garland',
  'Gastonia',
  'Gilbert',
  'Glendale',
  'Grand Prairie',
  'Grand Rapids',
  'Grayslake',
  'Green Bay',
  'GreenBay',
  'Greensboro',
  'Greenville',
  'Gulfport-Biloxi',
  'Hagerstown',
  'Hampton',
  'Harlingen',
  'Harrisburg',
  'Hartford',
  'Havre de Grace',
  'Hayward',
  'Hemet',
  'Henderson',
  'Hesperia',
  'Hialeah',
  'Hickory',
  'High Point',
  'Hollywood',
  'Honolulu',
  'Houma',
  'Houston',
  'Howell',
  'Huntington',
  'Huntington Beach',
  'Huntsville',
  'Independence',
  'Indianapolis',
  'Inglewood',
  'Irvine',
  'Irving',
  'Jackson',
  'Jacksonville',
  'Jefferson',
  'Jersey City',
  'Johnson City',
  'Joliet',
  'Kailua',
  'Kalamazoo',
  'Kaneohe',
  'Kansas City',
  'Kennewick',
  'Kenosha',
  'Killeen',
  'Kissimmee',
  'Knoxville',
  'Lacey',
  'Lafayette',
  'Lake Charles',
  'Lakeland',
  'Lakewood',
  'Lancaster',
  'Lansing',
  'Laredo',
  'Las Cruces',
  'Las Vegas',
  'Layton',
  'Leominster',
  'Lewisville',
  'Lexington',
  'Lincoln',
  'Little Rock',
  'Long Beach',
  'Lorain',
  'Los Angeles',
  'Louisville',
  'Lowell',
  'Lubbock',
  'Macon',
  'Madison',
  'Manchester',
  'Marina',
  'Marysville',
  'McAllen',
  'McHenry',
  'Medford',
  'Melbourne',
  'Memphis',
  'Merced',
  'Mesa',
  'Mesquite',
  'Miami',
  'Milwaukee',
  'Minneapolis',
  'Miramar',
  'Mission Viejo',
  'Mobile',
  'Modesto',
  'Monroe',
  'Monterey',
  'Montgomery',
  'Moreno Valley',
  'Murfreesboro',
  'Murrieta',
  'Muskegon',
  'Myrtle Beach',
  'Naperville',
  'Naples',
  'Nashua',
  'Nashville',
  'New Bedford',
  'New Haven',
  'New London',
  'New Orleans',
  'New York',
  'New York City',
  'Newark',
  'Newburgh',
  'Newport News',
  'Norfolk',
  'Normal',
  'Norman',
  'North Charleston',
  'North Las Vegas',
  'North Port',
  'Norwalk',
  'Norwich',
  'Oakland',
  'Ocala',
  'Oceanside',
  'Odessa',
  'Ogden',
  'Oklahoma City',
  'Olathe',
  'Olympia',
  'Omaha',
  'Ontario',
  'Orange',
  'Orem',
  'Orlando',
  'Overland Park',
  'Oxnard',
  'Palm Bay',
  'Palm Springs',
  'Palmdale',
  'Panama City',
  'Pasadena',
  'Paterson',
  'Pembroke Pines',
  'Pensacola',
  'Peoria',
  'Philadelphia',
  'Phoenix',
  'Pittsburgh',
  'Plano',
  'Pomona',
  'Pompano Beach',
  'Port Arthur',
  'Port Orange',
  'Port Saint Lucie',
  'Port St. Lucie',
  'Portland',
  'Portsmouth',
  'Poughkeepsie',
  'Providence',
  'Provo',
  'Pueblo',
  'Punta Gorda',
  'Racine',
  'Raleigh',
  'Rancho Cucamonga',
  'Reading',
  'Redding',
  'Reno',
  'Richland',
  'Richmond',
  'Richmond County',
  'Riverside',
  'Roanoke',
  'Rochester',
  'Rockford',
  'Roseville',
  'Round Lake Beach',
  'Sacramento',
  'Saginaw',
  'Saint Louis',
  'Saint Paul',
  'Saint Petersburg',
  'Salem',
  'Salinas',
  'Salt Lake City',
  'San Antonio',
  'San Bernardino',
  'San Buenaventura',
  'San Diego',
  'San Francisco',
  'San Jose',
  'Santa Ana',
  'Santa Barbara',
  'Santa Clara',
  'Santa Clarita',
  'Santa Cruz',
  'Santa Maria',
  'Santa Rosa',
  'Sarasota',
  'Savannah',
  'Scottsdale',
  'Scranton',
  'Seaside',
  'Seattle',
  'Sebastian',
  'Shreveport',
  'Simi Valley',
  'Sioux City',
  'Sioux Falls',
  'South Bend',
  'South Lyon',
  'Spartanburg',
  'Spokane',
  'Springdale',
  'Springfield',
  'St. Louis',
  'St. Paul',
  'St. Petersburg',
  'Stamford',
  'Sterling Heights',
  'Stockton',
  'Sunnyvale',
  'Syracuse',
  'Tacoma',
  'Tallahassee',
  'Tampa',
  'Temecula',
  'Tempe',
  'Thornton',
  'Thousand Oaks',
  'Toledo',
  'Topeka',
  'Torrance',
  'Trenton',
  'Tucson',
  'Tulsa',
  'Tuscaloosa',
  'Tyler',
  'Utica',
  'Vallejo',
  'Vancouver',
  'Vero Beach',
  'Victorville',
  'Virginia Beach',
  'Visalia',
  'Waco',
  'Warren',
  'Washington',
  'Waterbury',
  'Waterloo',
  'West Covina',
  'West Valley City',
  'Westminster',
  'Wichita',
  'Wilmington',
  'Winston',
  'Winter Haven',
  'Worcester',
  'Yakima',
  'Yonkers',
  'York',
  'Youngstown',
]

export const ranks = ['Unranked', 'Lead', 'Contact', 'Prospect', 'Buyer', 'Evaluator', 'Customer']
